export { default as ArrowNarrowUpOutlineIcon } from './ArrowNarrowUpOutlineIcon';
